import { Component, OnInit} from '@angular/core';
import { GTopicService } from './g-topic.service'
import { Location } from '@angular/common';
import { GeneralComponent } from './g.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';

export abstract class GeneralExamComponent extends GeneralComponent implements OnInit{

  //all exams
  id: number;
  allQuestions: any[];
  protected solveInorder: boolean;
  protected isExam:boolean;
  title: string;
  description: string;
  protected configuration;
  protected key: string;
  protected solveNow: number[] = [];


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: GTopicService, protected _location: Location, protected router: Router, protected modalService: NgbModal) {
    super(topicService);
  }

  /** performed after the constructor */
  ngOnInit(){
    //load the configuration and the state
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.getConfiguration();
    this.getState();

    //set the properties
    this.title = this.configuration["title"];
    this.description = this.configuration["description"];
    this.isExam = this.configuration["isExam"];
    this.allQuestions = this.topicService.getAllQuestionInfosById(this.id);
    this.solveInorder = this.configuration["solveInOrder"];

    //compute the solvable exercises
    if(!this.solveInorder){
      for(let question of this.allQuestions)
      this.solveNow.push(question.id);
    } else {
      let oldQuestion = undefined;
      for(let question of this.allQuestions){
        if(oldQuestion != undefined){
          if(oldQuestion.solved){
            this.solveNow.push(question.id);
          }
        } else {
          this.solveNow.push(question.id);
        }
        oldQuestion = question;
      }
    }
    this.setTypeSpecificsFromConfiguration();
  }

  /** get the configuration of the exam by id */
  getConfiguration(){
    this.configuration = this.topicService.getExamById(this.id);
  }

  /**get the state of the topic by the topic key */
  getState(){
    this.state = this.topicService.getStateByKey(this.configuration.key);
  }

  /** sets the information from Confirguration */
  setTypeSpecificsFromConfiguration(){
    //there are no tstandard ypespecific information
    //the method has to be reimplemented in the subclasses on need
  }

  /** asks for confirmation to open if necessary */
  open(content) {
    if (this.topicService.isExam(this.configuration.id) && !this.solved()) {
      //if the exercise set is an exam, ask for confirmation before opening the evaluation
      this.modalService.open(content).result.then((result) => {
        this.router.navigate(['evaluation'], { relativeTo: this.activatedRoute });
      }, (reason) => {

      });
    } else {
      this.router.navigate(['evaluation'], { relativeTo: this.activatedRoute });
    }
  }

  /** checks whether the teachers place is visible */
  teachersPlaceIsVisible(): boolean{
    return this.topicService.isTeachersPlaceVisible();
  }

  /** is the exam already solved?
   * @returns boolean - is solved?
   */
  solved():boolean {
    return this.state.solved;
  }
/** resets the state of all exercises and the exercises set */
  resetState(){
    this.topicService.resetStateByKey(this.configuration.key);
    for(let q of this.allQuestions){
      this.topicService.resetStateByKey(q.key);
    }
    this.getState();
    this.title = this.configuration["title"];
  }



}